import { ApolloLinkScalar } from "@config/apollo/apollo-link.type";

export const PermissionScalar: ApolloLinkScalar<Record<string, Permission>> = {
    parseValue: (value: unknown) => {
        try {
            if (typeof value === "string") return JSON.parse(value);
            const objectValue = value as Record<string, {
                profileOperations: Permission["profileOperations"];
            }>;
            const patchedValues = Object.entries(objectValue).map(([key, value]) => {
                const newValue = {
                    profileOperations: value.profileOperations,
                };
                return [key, newValue];
            });
            return Object.fromEntries(patchedValues) as Record<string, Permission>;
            throw new Error("Couldn't parse a date : " + value);
        } catch (err) {
            console.error("Error parsing permissions scalar", err);
            return null;
        }
    },
    serialize: (value: unknown) => {
        if (value == null) return null;
        if (typeof value === "string") return value;
        return JSON.stringify(value);
        const error = new Error("Can't serialize the date object");
        console.error(error);
        throw error;
    },
};

export const ProfileEnum = {
    USER: "USER",
    ALL: "ALL",
    GROUP: "GROUP",
    ORGANIZATION: "ORGANIZATION",
    CLIENT: "CLIENT",
    SUBTENANT: "SUBTENANT",
} as const;

type ProfileEnum = keyof typeof ProfileEnum;

export const CrudOperation = {
    CREATE: "CREATE",
    READ: "READ",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
} as const;

type CrudOperation = keyof typeof CrudOperation;

export interface Operations {
    values: Array<CrudOperation>;
}

export interface Permission {
    profileOperations: Record<ProfileEnum, Operations>;
}
